import { CustomerType } from '@repo/common';
import { Button, Card, CardContent, CardHeader, CardTitle } from '@repo/shadcn';
import { Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

import { CustomerTypeBadge } from '@/components/ui/badge';
import { CopyToClipboardButton } from '@/components/ui/button';

import { useOrderDetailsContext } from './context';

export const CustomerInfo = () => {
    const { data } = useOrderDetailsContext();

    const customer = data?.data?.customer;

    const customerName = customer?.name ?? 'Walk-in Customer';
    const customerEmail = customer?.email ?? '---';
    const customerPhone = customer?.phone_number ?? '---';
    const customerAddress = customer?.address ?? '---';
    const customerSince = customer?.created_at
        ? new Date(customer.created_at).toLocaleDateString()
        : '---';

    const renderContactInfo = () => {
        if (!customer) {
            return null;
        }

        return (
            <div className="space-y-4">
                <div className="flex items-center justify-between gap-3 rounded-lg bg-muted p-3">
                    <div className="flex items-center gap-3">
                        <Mail className="h-4 w-4 text-muted-foreground" />
                        <div className="min-w-0">
                            <p className="text-xs text-muted-foreground">
                                Email
                            </p>
                            <p className="truncate text-sm font-medium">
                                {customerEmail}
                            </p>
                        </div>
                    </div>
                    <CopyToClipboardButton textToCopy={customerEmail} />
                </div>

                <div className="flex items-center justify-between gap-3 rounded-lg bg-muted p-3">
                    <div className="flex items-center gap-3">
                        <Phone className="h-4 w-4 text-muted-foreground" />
                        <div className="min-w-0">
                            <p className="text-xs text-muted-foreground">
                                Phone
                            </p>
                            <p className="truncate text-sm font-medium">
                                {customerPhone}
                            </p>
                        </div>
                    </div>
                    <CopyToClipboardButton textToCopy={customerPhone} />
                </div>
            </div>
        );
    };

    const renderCustomerSince = () => {
        if (!customer) {
            return null;
        }

        return (
            <div>
                <p className="text-xs font-semibold text-muted-foreground">
                    CUSTOMER SINCE
                </p>
                <p className="mt-1 text-sm font-medium">{customerSince}</p>
            </div>
        );
    };

    const renderCustomerName = () => {
        if (!customer) {
            return <CardTitle className="text-xl">{customerName}</CardTitle>;
        }
        const customerLink =
            customer?.customer_type === CustomerType.WHOLESALE
                ? `/wholesale-orders/customers/${customer.id}`
                : `/customers/${customer.id}`;
        return (
            <Link to={customerLink}>
                <Button asChild variant="link" className="p-0">
                    <CardTitle className="text-xl">{customerName}</CardTitle>
                </Button>
            </Link>
        );
    };

    return (
        <Card>
            <CardHeader>
                <div className="flex items-start justify-between">
                    <div>
                        {renderCustomerName()}
                        <p className="mt-1 text-xs text-muted-foreground">
                            {customerAddress}
                        </p>
                    </div>
                    <CustomerTypeBadge value={customer?.customer_type} />
                </div>
            </CardHeader>
            <CardContent className="space-y-6">
                {renderCustomerSince()}

                {/* Contact Info */}
                {renderContactInfo()}
            </CardContent>
        </Card>
    );
};

CustomerInfo.displayName = 'CustomerInfo';
